import {EsitoChiusuraFase, EsitoChiusuraFaseEnum, MotivoSaltoEnum} from '../_models/FasePrecedenteAperta';

/**
 * Testo dell'avviso per le righe/fasi a monte che la chiusura non ha chiuso, oppure `null` se sono
 * state chiuse tutte (issue #3477). Condiviso dal Termina operatore e dalla modale ordine (feature 151):
 * le due schermate devono dire la stessa cosa con le stesse parole.
 *
 * «Già terminata» non richiede alcun intervento, «invio fallito» sì: confonderli farebbe perdere la
 * segnalazione che conta.
 */
export function descriviFasiNonChiuse(precedenti: EsitoChiusuraFase[] | null | undefined): string | null {
  const nonChiuse = (precedenti ?? []).filter(e => e.esito !== EsitoChiusuraFaseEnum.Chiusa);
  if (nonChiuse.length === 0) {
    return null;
  }
  const dettaglio = nonChiuse
    .map(e => `Ordine ${e.idDocumento} · Riga ${e.idRiga} · Fase ${e.numFase}: ${motivoEsito(e)}`)
    .join('; ');
  return `${nonChiuse.length} fasi precedenti non chiuse — ${dettaglio}`;
}

function motivoEsito(esito: EsitoChiusuraFase): string {
  if (esito.esito === EsitoChiusuraFaseEnum.Errore) {
    return `errore (${esito.motivo ?? 'causa non nota'})`;
  }
  switch (esito.motivoSalto) {
    case MotivoSaltoEnum.GiaTerminata:
      return 'già terminata da un\'altra postazione, nessun intervento necessario';
    case MotivoSaltoEnum.InvioInCorso:
      return 'invio precedente ancora in corso, riprovare più tardi';
    case MotivoSaltoEnum.InvioFallito:
      return 'invio precedente fallito, va verificato';
    default:
      return esito.motivo ?? 'saltata';
  }
}
